import React from 'react';
import { Box, Typography } from '@mui/material';

const UpgradeToGetStarted = ({
  imageSrc,
  imageAlt,
  heading,
  description,
  lockIconSrc,
  promoText,
  buttonText,
  showTextContent = true, // control visibility
}) => {
  return (
    <div>
      <div
        style={{
          padding: '40px',
          textAlign: 'center',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          border: '1px solid #DFDFDF',
          borderRadius: '8px',
        }}
      >
        <img
          src={imageSrc}
          className="img-fluid"
          style={{height: '100%', objectFit: 'contain' ,  width: {xs: '100%' , sm: '100%'}}}
          alt={imageAlt}
        />

        {showTextContent && (
          <>
            <Typography
              sx={{
                fontSize: '22px',
                color: '#1A1F36',
                fontWeight: '600',
                margin: '0px auto 12px',
              }}
            >
              {heading}
            </Typography>

            <Typography
              sx={{
                 fontSize: {xl: '16px' , lg: '16px', md: '14px' , sm: '14px' , xs: '14px'},
                color: '#373737',
                fontWeight: '400',
                maxWidth: '650px',
              }}
            >
              {description}
            </Typography>
          </>
        )}

        <Box
          sx={{
            display: { xs: 'block', lg: 'flex' },
            alignItems: { sm: 'center' },
            justifyContent: { sm: 'space-between' },
            gap: { xs: 1, lg: 1 },
            backgroundColor: '#0076FE0A',
            padding: '1vh 12px',
            border: '1px solid #0076FE',
            borderRadius: '8px',
            margin: '4vh auto',
            height: { lg: '80px' },
          }}
        >
          <Typography
            sx={{
              // whiteSpace: 'nowrap',
              fontSize: {xl: '16px' , lg: '16px', md: '14px' , sm: '14px' , xs: '14px'},
              fontWeight: '500',
              color: '#0076FE',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginBottom: {sm: '10px' , xs: '10px'}
            }}
          >
            <img src={lockIconSrc} className="img-fluid" alt="Lock Icon" />
            {promoText}
          </Typography>

          <button
            style={{
              whiteSpace: 'nowrap',
              fontSize: '16px',
              fontWeight: '600',
              color: '#FFFFFF',
              padding: '8px 24px',
              backgroundColor: '#0076FE',
              borderRadius: '100px',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            {buttonText}
          </button>
        </Box>
      </div>
    </div>
  );
};

export default UpgradeToGetStarted;
